<template>
  <div class="d-inline-block">
    <div 
      v-if="seeThroughObjects.length > 0"
      class="mt-2 see-through-container"
    >
      <b-button
        v-b-tooltip.hover
        variant="outline-primary"
        size="sm"
        class="w-100 mt-3"
        title="Restore See-Through Objects"
        @click="showRestoreModal = true"
      >
        <i class="bi bi-arrow-counterclockwise" />
        Restore See-Through Objects
        <b-badge
          variant="warning"
          class="ml-1"
        >
          {{ seeThroughObjects.length }}
        </b-badge>
      </b-button>

      <b-modal
        v-model="showRestoreModal"
        title="Restore See-Through Objects"
        ok-title="Restore All"
        @ok="restoreAll"
      >
        <b-list-group>
          <b-list-group-item
            v-for="(obj, index) in seeThroughObjects"
            :key="obj.id || obj.element_id || index"
            class="d-flex justify-content-between align-items-center"
          >
            <span>{{ obj.name || obj.id || obj.element_id || 'Object ' + (index + 1) }}</span>
            <b-button
              size="sm"
              variant="primary"
              @click="restoreSingle(obj)"
            >
              Restore
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'RestoreSeeThrough',

    data() {
        return {
            showRestoreModal: false,
            refreshKey: 0,
        }
    },

    computed: {
        ...mapGetters('layout', [
            'selectedInstance',
        ]),

        seeThroughObjects() {
            this.refreshKey;

            if (!this.selectedInstance || !this.selectedInstance.canvas) {
                return [];
            }

            const objects = this.selectedInstance.canvas.getObjects();
            return objects.filter(obj => obj._isSeeThrough);
        },
    },

    mounted() {
        if (this.selectedInstance && this.selectedInstance.canvas) {
            this.selectedInstance.canvas.on('see-through:changed', this.handleSeeThroughChange);
        }
    },

    beforeDestroy() {
        if (this.selectedInstance && this.selectedInstance.canvas) {
            this.selectedInstance.canvas.off('see-through:changed', this.handleSeeThroughChange);
        }
    },

    methods: {
        handleSeeThroughChange() {
            this.refreshKey++;
        },

        restoreSingle(obj) {
            if (!obj) return;

            obj.set({
                opacity: obj._originalOpacity !== undefined ? obj._originalOpacity : 1,
                evented: true,
                selectable: true,
            });

            delete obj._isSeeThrough;
            delete obj._originalOpacity;

            if (obj.canvas) {
                obj.canvas.fire('see-through:changed', obj);
                obj.canvas.requestRenderAll();
            }

            this.showRestoreModal = false;
        },

        restoreAll() {
            const objectsToRestore = [...this.seeThroughObjects];

            objectsToRestore.forEach(obj => {
                obj.set({
                    opacity: obj._originalOpacity !== undefined ? obj._originalOpacity : 1,
                    evented: true,
                    selectable: true,
                });

                delete obj._isSeeThrough;
                delete obj._originalOpacity;

                if (obj.canvas) {
                    obj.canvas.fire('see-through:changed', obj);
                }
            });

            if (objectsToRestore.length > 0 && objectsToRestore[0].canvas) {
                objectsToRestore[0].canvas.requestRenderAll();
            }
        },
    },
}
</script>

<style scoped lang="scss"></style>
